import { NgModule } from '@angular/core';
import { DependenciesModule } from '../dependencies.module';
import { LaasRoutingModule } from './laas-routing.module';

import { LaasComponent } from './laas.component';
import { ApplicantService } from './applicant.service';
import { CommonFieldsService } from './common-fields.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ConsentDisabledComponent, ConsentFormComponent } from './consent-form/consent-form.component';
import { GeoMappingComponent } from './geo-mapping/geo-mapping.component';
import { FormsModule } from '@angular/forms';
import { LandRecordsMpComponent } from './land-records-mp/land-records-mp.component';
import { OpenDialogYesOrNo } from './dialog-yes-or-no/dialog-yes-or-no.component';
import { CibilReportService } from './financial/cibil-report/cibil-report.service';
import { FruitsLandRecordComponent } from './fruits-land-record/fruits-land-record.component';
import { LandRecordUpdateNewComponent } from './land-record-update-new/land-record-update-new.component';
import { LandRecordsApComponent } from './land-records-ap/land-records-ap.component';

import { MatLegacyCardModule } from '@angular/material/legacy-card';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ProfileComponent } from './dashboard/profile/profile.component';
import { LoanRenewalFormComponent } from './loan/shared/loan-renewal-form/loan-renewal-form.component';
import { CrifReportComponent } from './financial/cibil-report/cibil-report.component';
import { CrifReportViewComponent } from './financial/cibil-report/cibil-report-view/crif-report-view.component';
import { BreStatusCheckComponent } from './financial/bre-status/brestatuscheck.component';

 

@NgModule({
  imports: [
    DependenciesModule,
    LaasRoutingModule,
    ModalModule.forRoot(),
    FormsModule,
    MatLegacyMenuModule,
    MatSidenavModule,
    MatIconModule,
    MatLegacyCardModule,
    MatLegacyFormFieldModule,
    MatLegacyInputModule,
    MatLegacyRadioModule,
    MatLegacySelectModule,
    MatLegacyProgressBarModule,
    MatLegacyProgressSpinnerModule,



    // AppFormsModule
  ],
  declarations: [
    LaasComponent,
    // LoadDialogComponent,
    // BhoomiRtcComponent,
    ConsentFormComponent,
    GeoMappingComponent,
    ConsentDisabledComponent,
    LandRecordsMpComponent,
    OpenDialogYesOrNo,
    FruitsLandRecordComponent,
    LandRecordUpdateNewComponent,
    LandRecordsApComponent,
    ProfileComponent,
    LoanRenewalFormComponent,
    CrifReportComponent,
    CrifReportViewComponent,
    BreStatusCheckComponent
  ],
  providers: [ApplicantService, CommonFieldsService, CibilReportService],
  exports: [],
})
export class LaasModule {}
